module.exports = __webpack_public_path__ + "img/icon_qustion_bank.3c813a05.svg";